import React, { useEffect, useState, useCallback } from "react";
import { Button, Input, Select, Tag, Spin, Badge, Tooltip } from "antd";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import "./members.scss";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import OrganizationTable from "../table/table";
import PendingApprovalTable from "../table/pendingApprovalTable";
import Interests from "../json/interestsType.json";
import { toast } from "react-toastify";
import userServiceApi from "../../api/userServiceApi";
import { getRequest } from "../../api/http";
import Filter from "./filter";
import { useStore } from "../../store";
import backBtn from "../../assets/images/back-arrow.svg";
import { inputFieldCharLimit } from "../../config";
import { debounce } from 'lodash';
import { enumMismatchAdaptor } from "../../utils";
import { setTabInterestName } from "../../store/actions";

const FullMember = () => {
  const localAK = sessionStorage.getItem("activeKey");
  const navigate = useNavigate();
  const location = useLocation();
  const count  = location?.state?.pendingCount
  const [filterExists, setFilterExists] = useState(false);
  const [isPendingApproval, setIsPendingApproval] = useState(false);
  const [tableLoader, setTableLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [activeKey, setActiveKey] = useState(
    sessionStorage.getItem("activeKey")
      ? sessionStorage.getItem("activeKey")
      : "1"
  );
  sessionStorage.setItem("page", "full-members");
  const fullMemberCount = sessionStorage.getItem("fullPending");
  const [sectorName, setSectorName] = useState("");
  const [subSectorName, setSubSectorName] = useState("");
  const [tableData, setTableData] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(true);
  const [showTags, setShowTags] = useState(true);
  const [organizationName, setOrganisationName] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalOrgs, setTotalOrgs] = useState();
  const [sortDirection, setSortDirection] = useState();
  const [reviewPending, setReviewPending] = useState(false);
  const [sortBy, setSortBy] = useState();
  const [af, setAf] = useState("");
  const [gl, setGl] = useState("");
  const [ms, setMs] = useState("");
  const [tz, setTz] = useState("");
  const [boolaf, setBoolAf] = useState(false);
  const [boolgl, setBoolGl] = useState(false);
  const [boolms, setBoolMs] = useState(false);
  const [booltz, setBoolTz] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [masterDataIds,setMasterDataIds] = useState([])


  const [isReview, setisReview] = useState(false);
  const [reviewid, setreviewid] = useState();

  const { pendingFullMembersCount, deleteReviewsFullCount, dispatch } = useStore();

  const fetchMasterDataIds = useCallback(async()=>{
    const response = await getRequest(userServiceApi.getMasterDataIds())
    if(response?.data?.length){
      setMasterDataIds(response?.data)
    }
  },[])

  useEffect(()=>{
    fetchMasterDataIds()
  },[fetchMasterDataIds])

  // Ultra-strict sanitization
  const sanitizeSearchInput = (input) => {
    if (input === undefined || input === null) return '';
    if (typeof input !== 'string') return '';

    // Only allow: letters, numbers, spaces, hyphens, underscores
    const sanitized = input.replace(/[^a-zA-Z0-9\s\-_]/g, '');

    console.log('🔍 Search Sanitization - Input:', `"${input}"`, 'Output:', `"${sanitized}"`);
    return sanitized;
  };

  // Safe URL parameter encoding
  const getSafeSearchParam = (input) => {
    if (!input || input.trim() === '') return '';

    const sanitized = sanitizeSearchInput(input.trim());
    if (!sanitized) return '';

    return encodeURIComponent(sanitized);
  };

  const reloadFunction = () => {
    filterMicrosites();
  }

  const ReviewHandler = (id) => {
    setisReview(true);
    setreviewid(id);
  };

  const handleBackClick = () => {
    setisReview(false);
    filterMicrosites();
  };

  const sortFunction = (direction) => {
    setSortDirection(direction);
  };

  const reviewPendingFunction = (reviewPendingState) => {
    setReviewPending(reviewPendingState);
    if (reviewPendingState === true) {
      getReviewPendingData(reviewPendingState);
    } else {
      filterMicrosites();
    }
  };

  const sortByFunction = (sortByValue) => {
    setSortBy(sortByValue);
  };

  const handlePagNumber = (number) => {
    setPageNumber(number - 1);
  };

  const [interestName, setinterestName] = useState(
    sessionStorage.getItem("Interest/AssetType")
      ? sessionStorage.getItem("Interest/AssetType")
      : null
  );

  const [selectedEvent, setselectedEvent] = useState(
    sessionStorage.getItem("Interest/AssetType")
      ? sessionStorage.getItem("Interest/AssetType")
      : null
  );
  const [sectorId, setSectorId] = useState(
    sessionStorage.getItem("sector") ? sessionStorage.getItem("sector") : null
  );

  const [subsectorId, setSubsectorId] = useState(
    sessionStorage.getItem("subsector")
      ? sessionStorage.getItem("subsector")
      : null
  );

  const [size, setSize] = useState(
    sessionStorage.getItem("size") ? sessionStorage.getItem("size") : null
  );

  const [updateFilterData, setUpdateFilterData] = useState(false);

  useEffect(() => {
    clearAll();
  }, []);

  const showSearchBarHandler = (value) => {
    setShowSearchBar(value);
  };

  const showTagsHandler = (value) => {
    setShowTags(value);
  };

  const [reviewCount, setReviewCount] = useState([]);

  const filterMicrosites = async (searchValue = null) => {
    try {
      setTableLoader(true);
      let response;

      let safeSearchTerm = '';
      const currentSearchTerm = searchValue ?? searchTerm;

      if (currentSearchTerm && currentSearchTerm.trim() !== '') {
        safeSearchTerm = getSafeSearchParam(currentSearchTerm);
      }

      console.log('🌐 API Call - Search Term:', {
        original: currentSearchTerm,
        safe: safeSearchTerm,
        pageNumber,
        pageSize
      });
      const masterDataEnum = enumMismatchAdaptor(interestName)
      const masterDataId = masterDataIds?.find((e)=>e?.enumValue === masterDataEnum)?.id
      if(interestName) {
        dispatch(setTabInterestName(interestName))
      }
      response = await getRequest(
        userServiceApi.getAllFilterOrganizations(
          pageSize,
          pageNumber,
          interestName,
          sectorId,
          subsectorId,
          size,
          safeSearchTerm, // Use safe search term
          sortDirection,
          sortBy,
          af,
          gl,
          ms,
          tz,
          masterDataId
        )
      );

      response.data.result.sort(function (a, b) {
        a = a.approvalStatus.toLowerCase();
        b = b.approvalStatus.toLowerCase();
        return a < b ? -1 : a > b ? 1 : 0;
      });

      setTableData(response.data.result);
      setTotalOrgs(response?.data?.totalCount);
      setFilterExists(true);
    } catch (error) {
      console.error("Error filtering microsites:", error);
      toast.error(error?.error || "Failed to load organizations");
      setTableData([]);
    } finally {
      setTableLoader(false);
    }
  };

  // Debounced search
  const debouncedSearch = useCallback(
    debounce((value) => {
      filterMicrosites(value);
    }, 600),
    [pageSize, pageNumber, interestName, masterDataIds, sectorId, subsectorId, size, sortDirection, sortBy, af, gl, ms, tz]
  );

  // Search change handler
  const handleSearchChange = (e) => {
    const rawValue = e.target.value || '';
    const sanitizedValue = sanitizeSearchInput(rawValue);

    setSearchTerm(sanitizedValue);

    if (sanitizedValue.trim().length > 0) {
      debouncedSearch(sanitizedValue);
    } else {
      // If search is cleared, get all data
      filterMicrosites('');
    }
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchTerm("");
    filterMicrosites('');
  };

  // Handle enter key press
  const handlePressEnter = (e) => {
    const rawValue = e.target.value || '';
    const sanitizedValue = sanitizeSearchInput(rawValue);

    if (sanitizedValue.trim().length > 0) {
      filterMicrosites(sanitizedValue);
    }
  };

  //Move this to different page
  const getReviewPendingData = async (reviewPendingState) => {
    try {
      setTableLoader(false);
      let response;
      const getPendingCount = true;
      response = await getRequest(
        userServiceApi.getReviewPendingData(
          getPendingCount,
          reviewPending || reviewPendingState
        )
      );
      setTableData(response.data.result);
      setTotalOrgs(response?.data?.totalCount);
      setReviewCount(response?.data?.result);
    } catch (error) {
      console.error("Error getting review pending data:", error);
      toast.error(error?.error || "Failed to load review data");
    } finally {
      setTableLoader(false);
    }
  };

  useEffect(() => {
    filterMicrosites();
  }, [pageNumber, sortDirection, af, gl, ms, tz]);

  useEffect(() => {
    filterMicrosites();
  }, [localAK]);

  const RemoveHandler = (value) => {
    sessionStorage.removeItem(value);
    if (value === "interest") {
      sessionStorage.removeItem("Interest/AssetType");
      setinterestName(null);
      setselectedEvent(null);
    }
    if (value === "sector") {
      setSectorId(null);
      setSubsectorId(null);
      sessionStorage.removeItem("subsector");
    }
    if (value === "subsector") {
      setSubsectorId(null);
    }
    if (value === "size") {
      setSize(null);
    }
    setUpdateFilterData(!updateFilterData);
    filterMicrosites();
  };

  const setFilterHandler = async (sectorId, subSectorIds, size) => {
    if (sectorId && subSectorIds) {
      try {
        const partnerId = sessionStorage.getItem("partnerId");

        // fetch all sectors and find selected one
        const sectorResponse = await getRequest(userServiceApi.getAllSectors(partnerId, "SECTOR"));
        const selectedSector = sectorResponse.data.find(
          (sector) => sector.id === sectorId
        );
        setSectorName(selectedSector?.name || "");

        // fetch sub-sectors and find selected one
        const subSectorResponse = await getRequest(
          userServiceApi.getSubSectors(sectorId, "SUB_SECTOR")
        );
        const selectedSubSector = subSectorResponse.data.find(
          (sub) => sub.id === subSectorIds
        );
        setSubSectorName(selectedSubSector?.name || "");

        // set values
        setSectorId(sectorId);
        setSubsectorId(subSectorIds);
        setSize(size);
      } catch (error) {
        console.error("Error in setFilterHandler:", error);
      }
    } else {
      setSize(size);
    }
  };

  useEffect(() => {
    filterMicrosites();
  }, [interestName, sectorId, subsectorId, size, masterDataIds]);

  const interestChange = (e) => {
    sessionStorage.setItem("Interest/AssetType", e);
    setinterestName(e);
    setselectedEvent(e);
  };

  const handleAF = () => {
    if (!boolaf) {
      setAf("A-F");
      setBoolAf(true);
    } else {
      setAf("");
      setBoolAf(false);
    }
  };

  const handleGL = () => {
    if (!boolgl) {
      setGl("G-L");
      setBoolGl(true);
    } else {
      setGl("");
      setBoolGl(false);
    }
  };

  const handleMS = () => {
    if (!boolms) {
      setMs("M-S");
      setBoolMs(true);
    } else {
      setMs("");
      setBoolMs(false);
    }
  };

  const handleTZ = () => {
    if (!booltz) {
      setTz("T-Z");
      setBoolTz(true);
    } else {
      setTz("");
      setBoolTz(false);
    }
  };

  const clearAll = () => {
    sessionStorage.removeItem("Interest/AssetType");
    setSubSectorName("");
    setinterestName(null);
    setselectedEvent(null);
    setSectorId(null);
    setSubsectorId(null);
    setSize(null);
    sessionStorage.removeItem("subsector");
    setSearchTerm("");
  }

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  if (loader) {
    return (
      <div className="data-loader">
        <Spin className="spin" tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div className="tabContainer">
        <div className="main-container" style={{ paddingTop: "5px" }}>
          <div className="header-container">
            <div className="backbtn-container">
              <img
                src={backBtn}
                onClick={() => {
                  navigate('/partner-org')
                  setActiveKey("1");
                  clearAll();
                }}
                alt="Back"
                style={{ cursor: 'pointer' }}
              />
              <p>Full members</p>
            </div>
            <div className="btns">
              <div className="pending-btn">
                <Badge count={location?.state?.pendingCount || fullMemberCount || ''} showZero overflowCount={20}>
                  <Button
                    className="pending-badge"
                    onClick={() => navigate('/full-pending', { state: { page: "full-members" } })}
                  >
                    Pending Approvals
                  </Button>
                </Badge>
              </div>
              <div className="pending-btn">
                <Badge count={deleteReviewsFullCount} showZero overflowCount={10}>
                  <Button
                    className="pending-badge"
                    onClick={() => navigate('/full-delete-reviews', { state: { page: "full-members" } })}
                  >
                    Review requests
                  </Button>
                </Badge>
              </div>
            </div>
          </div>
          <div className="filters-container">
            <div className="search-bar-container">
              <Tooltip placement="top" title='Allowed: letters, numbers, spaces, hyphens (-), and underscores (_).'>
                <Input
                  size="large"
                  className="input"
                  placeholder="Search Organisation"
                  suffix={
                    searchTerm ? (
                      <CloseOutlined
                        style={{ color: "#CC0E2D", verticalAlign: "middle", cursor: 'pointer' }}
                        onClick={handleClearSearch}
                      />
                    ) : (
                      <SearchOutlined />
                    )
                  }
                  onChange={handleSearchChange}
                  onPressEnter={handlePressEnter}
                  value={searchTerm}
                  maxLength={inputFieldCharLimit}
                />
              </Tooltip>
            </div>
            <div className="filter-btn">
              <Filter
                mask={false}
                interest={selectedEvent}
                setData={setFilterHandler}
                updateFilterData={updateFilterData}
                span={9}
              />
            </div>
            <div className="interests-container">
              <Select
                className="select-drpdwn"
                value={interestName}
                placeholder="Select Interest"
                onChange={(e) => interestChange(e)}
              >
                {Interests.map((Interest, i) => (
                  <Select.Option key={i} value={Interest.id}>
                    {Interest.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className="alphabet-filters">
              <Button
                id="A-F-btn"
                className={`alpha-filter-btn ${boolaf ? `selected` : ``}`}
                onClick={handleAF}
              >
                A-F
              </Button>
              <Button
                id="G-L-btn"
                className={`alpha-filter-btn ${boolgl ? `selected` : ``}`}
                onClick={handleGL}
              >
                G-L
              </Button>
              <Button
                id="M-S-btn"
                className={`alpha-filter-btn ${boolms ? `selected` : ``}`}
                onClick={handleMS}
              >
                M-S
              </Button>
              <Button
                id="T-Z-btn"
                className={`alpha-filter-btn ${booltz ? `selected` : ``}`}
                onClick={handleTZ}
              >
                T-Z
              </Button>
            </div>
          </div>
          <div>
            {showTags ? (
              <div className="org-filter-options">
                <div className="filter-options">
                  {interestName ? (
                    <Tag
                      closable
                      onClose={RemoveHandler.bind(this, "interest")}
                    >
                      {interestName === "APPRENTICESHIP"
                        ? "Apprenticeship"
                        : interestName === "VACANCY"
                          ? "Vacancies"
                          : interestName === "PRODUCT"
                            ? "Products"
                            : interestName === "SERVICE"
                              ? "Service"
                              : interestName === "WORK_EXPERIENCE"
                                ? "Experience of work"
                                : interestName === "COURSES"
                                ? "Courses"
                                : interestName === 'CONTRACTS'
                                ? "Contracts" : ""
                                }
                    </Tag>
                  ) : null}
                  {sectorId ? (
                    <Tag
                      closable
                      onClose={RemoveHandler.bind(this, "sector")}
                    >
                      {sectorName}
                    </Tag>
                  ) : null}
                  {subsectorId ? (
                    <Tag
                      closable
                      onClose={RemoveHandler.bind(this, "subsector")}
                    >
                      {subSectorName}
                    </Tag>
                  ) : null}
                  {size ? (
                    <Tag closable onClose={RemoveHandler.bind(this, "size")}>
                      {size === "MICRO"
                        ? "Micro"
                        : size === "SMALL"
                          ? "Small"
                          : size === "MEDIUM"
                            ? "Medium"
                            : size === "LARGE"
                              ? "Large"
                              : ""}
                    </Tag>
                  ) : null}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          {!tableLoader ? (
            <OrganizationTable
              activeKey={activeKey}
              reloadFunction={reloadFunction}
              data={tableData}
              filterExists={filterExists}
              showSearchBarHandler={showSearchBarHandler}
              showTagsHandler={showTagsHandler}
              pagNumber={handlePagNumber}
              totalOrgs={totalOrgs}
              sortFunction={sortFunction}
              reviewPendingFunction={reviewPendingFunction}
              sortByFunction={sortByFunction}
              ReviewHandler={ReviewHandler}
              handleBackClick={handleBackClick}
              reviewCount={reviewCount}
            />
          ) : (
            <div className="data-loader">
              <Spin className="spin" tip="Loading organizations..." size="large" />
            </div>
          )}
        </div>
      </div>
    );
  }
};
export default FullMember;